import { useState, useEffect } from "react";
import {
  CreateLead,
  fetchDefects,
  fetchDevices,
} from "../../actions/client/devices";
import GeneralSelectBar from "../../components/admin/GeneralSelectBar";
import { fetchDeviceByCategory } from "../../actions/admin/leads";
import { deliveryCat } from "../../constants/stepper";
import { fetchEstimates } from "../../actions/client/estimates";
import { toast } from "react-toastify";
import { redirect, useNavigate } from "react-router-dom";

const ClientCreateLead = () => {
  const [userData, setUserData] = useState([]);
  const [deviceCategory, setDeviceCategory] = useState([]);
  const [deviceData, setDevicedata] = useState([]);
  const [defectsData, setDefectsData] = useState([]);
  const [leads, setLeads] = useState([]);
  const [isDevice, setIsDevice] = useState("imei_no");
  const [inputLeadData, setInputLeadData] = useState({
    category_id: "",
    brand_id: "",
    imei_no: "",
    serial_no: "",
    delivery_type: "",
    defects: [],
    devices: [],
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userDatastr = localStorage.getItem("userDetails");
    setUserData(JSON.parse(userDatastr));

    fetchDevices(token).then((res) => {
      setDeviceCategory(res.data);
    });
    fetchDefects().then((res) => {
      setDefectsData(res.data);
    });
    fetchEstimates(token).then((res) => {
      setLeads(res.data);
    });
  }, []);

  console.log("ledas", leads);

  const getDevicesByCategoryID = (id) => {
    if (id) {
      fetchDeviceByCategory(id).then((res) => {
        setDevicedata(res.data);
      });
    }
  };
  const navigate = useNavigate();

  const handleFormSubmit = async () => {
    const token = localStorage.getItem("token");
    const data = {
      first_name: leads[0]?.user?.first_name,
      last_name: leads[0]?.user?.last_name,
      email: leads[0]?.user?.email,
      phone: leads[0]?.customer?.phone,
      address: leads[0]?.customer?.address,
      zip_code: leads[0]?.customer?.zip_code,
      city: leads[0]?.customer?.city,
      state: leads[0]?.customer?.state,
      country: leads[0]?.customer?.country,
      compliance: true,
      reference: leads[0]?.reference,
      message: "test",
      lead_items: [inputLeadData],
    };

    try {
        const res = await CreateLead(data, token);

        if(res.success){
            toast.success("Your Lead has been created")
            setTimeout(() => {
                navigate("/client")
            },1000)
        }else{
            toast.error("Oops, Something went wrong")
        }
      } catch (error) {
        toast.error("Oops, Something went wrong")
        console.error("API Error", error);
      }
      
  };

  const handleCategoryChange = (item) => {
    setInputLeadData((prev) => ({ ...prev, category_id: item.id }));
    getDevicesByCategoryID(item.id); // Fetch devices for that category
  };

  const handleDeviceChange = (item) => {
    setInputLeadData((prev) => ({
      ...prev,
      devices: [
        {
          id: item.id,
          title: item.title,
          category_id: item.category_id,
        },
      ],
    }));
    setInputLeadData((prev) => ({ ...prev, brand_id: item.brand_id }));
  };

  const handleDefectsChange = (item) => {
    setInputLeadData((prev) => ({
      ...prev,
      defects: [
        {
          id: item.id,
          title: item.title,
        },
      ],
    }));
  };

  const handleDeliveryTypeChange = (item) => {
    setInputLeadData((prev) => ({ ...prev, delivery_type: item.name }));
  };


  return (
    <div className="container">
      <div className="row d-flex justify-content-center align-items-center mt-5 mb-3">
        <h2>Create Lead</h2>
      </div>
      <div className="card rounded shadow p-2">
        <div className="row p-4">
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <h4>
              Hi, {userData.first_name} {userData.last_name}{" "}
            </h4>
            <p > Please Provide Device Details to Create New Lead </p>

            <p className="mb-0"> <strong>Here's your personal Details</strong></p>

            <p className="mb-0">Email: {leads[0]?.user?.email}</p>
            <p className="mb-0">Phone: {leads[0]?.customer?.phone}</p>
            <p className="mb-0">Address: {leads[0]?.customer?.address}, {leads[0]?.customer?.city} {leads[0]?.customer?.state}, {leads[0]?.customer?.country} - {leads[0]?.customer?.zip_code}</p>


          </div>
          <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
            <form onSubmit={(e) => { e.preventDefault(); handleFormSubmit(); }}  className="row">
              <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                <label className="form-label">Select Category</label>
                {deviceCategory && deviceCategory.length > 0 && (
                  <GeneralSelectBar
                    dataset={deviceCategory}
                    onValueChange={(e) => handleCategoryChange(e)}
                    name="Select Category"
                  />
                )}
              </div>
              <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                <label className="form-label">Select Device</label>
                <GeneralSelectBar
                  dataset={deviceData}
                  onValueChange={handleDeviceChange}
                  name="Select Device"
                />
              </div>
              <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 mt-3">
                <label className="form-label">Select Defects</label>
                <GeneralSelectBar
                  dataset={defectsData}
                  onValueChange={handleDefectsChange}
                  name="Select Defects"
                />
              </div>
              <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 mt-3">
                <label className="form-label">Select Delivery Type</label>
                <GeneralSelectBar
                  dataset={deliveryCat}
                  onValueChange={handleDeliveryTypeChange}
                  name="Select Delivery Type"
                />
              </div>
              <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 mt-3">
                <select
                  className="border-0 mb-2"
                  onChange={(e) => setIsDevice(e.target.value)}
                >
                  <option value="imei_no">IMEI No.</option>
                  <option value="serial_no">Serial No.</option>
                </select>
                {/* <label className="form-label">IMEI No.</label>    */}
                {isDevice == "imei_no" ? (
                  <input
                    type="text"
                    className="form-control "
                    placeholder="Enter IMEI No."
                    onChange={(e) => setInputLeadData({...inputLeadData, imei_no: e.target.value})}
                  />
                ) : (
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Serial No."
                    onChange={(e) => setInputLeadData({...inputLeadData, serial_no: e.target.value})}
                  />
                )}
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-4 ">
                <button type="submit" className="btn bg-black text-white px-5">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientCreateLead;
